import {ObserverBase} from "@share/web-conferences/signal-r/observers/ObserverBase";
import {
    addRaisedHandAction,
    removeRaisedHandAction,
    setRaisedHandAction,
} from "@share/web-conferences/store/actions";
import {UserProfile} from "@api/models/UserProfile";
import {UserHandParam} from "@share/web-conferences/interfaces/signalr/UserHandParam";
import {UserHandState} from "@share/web-conferences/enums/UserHandState";
import {StoreParameters} from "@share/web-conferences/types/StoreParameters";
import {SignalRMethod} from "@api/repositories/reatime-repository/types";
import {ObserverData} from "@share/web-conferences/interfaces/signalr/ObserverData";

export class UserHandObserver extends ObserverBase {
    method = SignalRMethod.webConferenceUserHandsUpdate;

    constructor(readonly data: ObserverData) {
        super(data);
    }

    async callback(data: any): Promise<void> {
        console.log('user hand', data);
        try {
            const update = JSON.parse(data) as UserHandParam;

            if (update && update.users && update.users.length) {
                const users = update.users.map(item => new UserProfile(item));
                const action = update.type == UserHandState.Raised ? addRaisedHandAction : removeRaisedHandAction;
                this.data.store.dispatch(action, {
                    key: this.data.stateKey,
                    data: users
                } as StoreParameters<UserProfile[]>);
            }
        }
        catch (e) {
            this.data.store.dispatch('reportError', e);
        }
    }

    async processConnect(connectResult: UserHandParam) {
        if (connectResult) {
            this.data.store.dispatch(setRaisedHandAction, {
                key: this.data.stateKey,
                data: connectResult?.users ? connectResult.users.map(item => new UserProfile(item)) : []
            } as StoreParameters<UserProfile[]>);
        }
    }
}
